"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.176.2
//   protoc               v4.23.4
// source: tac-operation-lifecycle-proto/proto/v1/statistic.proto
Object.defineProperty(exports, "__esModule", { value: true });
